import React, { useState, useEffect, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';

// Importando componentes
import Card from '~/components/Card';
import Load from '~/components/Load';
import Table from '~/components/Table';

import { Container, Menus, NewButton } from './styles';

export default function Cadencia() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  // Puxando dados de cadencia
  const getCadencia = useCallback(async () => {
    setLoading(true);
    const response = await api.get(`/cadencia`);
    setDados(response.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    getCadencia();
  }, [getCadencia]);

  /**
   * Funcoes
   */

  async function handlerDelete(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/cadencia/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Cadência excluida com sucesso');
            getCadencia();
          }
        });
      } else {
        const response = await api.delete(`/cadencia/${number}`);

        if (response.data) {
          toast.success('Cadência excluida com sucesso');
          getCadencia();
        }
      }
    } catch (error) {
      toast.error('Erro ao deletar cadência');
      getCadencia();
    } finally {
      setLoading(false);
    }
  }

  async function handleEditar(number) {
    history.push(`/cadencia-edit/${number}`);
  }
  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Cadência</h4>
      <Card>
        <Menus>
          <NewButton to="/cadencia-create">
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={dados}
          columns={columns}
          ds={handlerDelete}
          ed={handleEditar}
          messages="Voce deseja excluir(s) cadencia(s) ?"
          st
        />
      </Card>
    </Container>
  );
}
